export let serviceWorker

export const initServiceWorker = async () => {
	console.log('initServiceWorker')
	if ('serviceWorker' in navigator) {
		const registration = await navigator.serviceWorker.register('/sw.js', {
			scope: './'
		})

		serviceWorker = registration
		console.log('SW', serviceWorker)
		serviceWorker.update()
	}
}

